export const LOADING_SET = 'externalContent/welcome/LOADING_SET'
export const POPUP_VISIBLE_SET = 'externalContent/welcome/POPUP_VISIBLE_SET'
export const SHOW_EXTERNAL_CONTENT_SET = 'exernalContent/welcome/SHOW_EXTERNAL_CONTENT_SET'
export const DEMO_DATA_STAGE_SET = 'externalContent/welcome/DEMO_DATA_STAGE_SET'
export const URL_SET = 'externalContent/welcome/URL_SET'
export const SIZE_SET = 'externalContent/welcome/SIZE_SET'


// WEBPACK FOOTER //
// ./web/js/support/welcomeScreen/actionTypes.js